import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoutes = ({ children, permissionKey }) => {
  let token = localStorage.getItem('token');
  const InitialPermissionData = useSelector(
    (state) => state.persistedReducer.forms.savedPermissions
  );
  const { permissions, userId, roleName } = InitialPermissionData ?? {};
  console.log('========User ID======', userId)

  // Permission check
  const idToCheck = permissions.find(
    (p) => p.id === permissionKey || p.name === permissionKey
  )?.id;

  // Check if token exist
  if (!token) {
    const lastPath = location.pathname;
    sessionStorage.setItem('last path', lastPath);
    return <Navigate to="/" />;
  }

  if (roleName !== "SUPER_ADMIN" && permissionKey && !idToCheck) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

ProtectedRoutes.propTypes = {
  children: PropTypes.node.isRequired,
  permissionKey: PropTypes.string
};

export default ProtectedRoutes;
